<map-header></map-header>
<div class="main-container">
    <router-outlet></router-outlet>
</div>

